<template>
    <b-container>
        <div class="row py-4">
            <div class="col-12 text-center text-dark">
                Manage user access
            </div>
        </div>

        <div class="row">
            <div class="col-12">
                <div id="accordion">
                    <div class="card">
                        <div class="card-header bg-grey-light">
                            <a class="card-link text-dark"
                               data-toggle="collapse"
                               href="#ChoosePermissions">
                                Choose permissions
                            </a>
                        </div>
                        <div id="ChoosePermissions"
                             class="collapse show"
                             data-parent="#accordion">
                            <div class="card-body bg-white">
                                <div class="row">
                                    <div class="col-12 pb-3">
                                        <div class="d-flex justify-content-between align-items-center">
                                            <h4 class="text-dark">Choose permissions</h4>
                                            <div>
                                                <input type="checkbox" id="expandAll">
                                                <label for="expandAll">Expand all permissions</label>
                                            </div>
                                        </div>
                                    </div>

                                    <!-- Sidebar -->
                                    <div class="col-md-3 sidebar">
                                        <div class="min-w-25 search-container">
                                            <input type="text"
                                                   class="form-control focus:border-followup-nav"
                                                   placeholder="Search">
                                            <i class="fa fa-search text-primary"></i>
                                        </div>

                                        <div class="row p-3">
                                            <ul class="list-group">
                                                <li class="p-2 bg-followup-nav text-white">CRM Objects</li>
                                                <li class="text-dark py-2">CRM Tools</li>
                                                <li class="text-dark py-2">Automation</li>
                                            </ul>
                                        </div>

                                        <a href="#" class="text-primary d-block mt-3">Learn more about permissions</a>
                                    </div>

                                    <!-- Permissions Content -->
                                    <div class="col-md-9">
                                        <!-- Projects Section -->
                                        <div id="accordion3">
                                            <div class="card">
                                                <div class="card-header bg-grey-light">
                                                    <a class="card-link text-dark"
                                                       data-toggle="collapse"
                                                       href="#ProjectPermissions">
                                                        Projects
                                                    </a>
                                                </div>
                                                <div id="ProjectPermissions"
                                                     class="collapse show"
                                                     data-parent="#accordion3">
                                                    <div class="card-body bg-white">
                                                        <div class="d-flex align-items-center justify-content-between mt-2">
                                                            <span class="text-dark">View</span>
                                                            <select class="custom-select w-auto">
                                                                <option>All projects</option>
                                                            </select>
                                                        </div>
                                                        <div class="d-flex align-items-center justify-content-between mt-2">
                                                            <span class="text-dark">Edit</span>
                                                            <select class="custom-select w-auto">
                                                                <option>All projects</option>
                                                            </select>
                                                        </div>
                                                        <div class="d-flex align-items-center justify-content-between mt-2">
                                                            <span class="text-dark">Delete <span class="badge badge-danger">CRITICAL</span></span>
                                                            <select class="custom-select w-auto">
                                                                <option>All projects</option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <!-- Contacts Section -->
                                        <div id="accordion1">
                                            <div class="card">
                                                <div class="card-header bg-grey-light">
                                                    <a class="card-link text-dark"
                                                       data-toggle="collapse"
                                                       href="#ContactPermissions">
                                                        Contacts
                                                    </a>
                                                </div>
                                                <div id="ContactPermissions"
                                                     class="collapse show"
                                                     data-parent="#accordion1">
                                                    <div class="card-body bg-white">
                                                        <div class="d-flex align-items-center justify-content-between mt-2">
                                                            <span class="text-dark">View</span>
                                                            <select class="custom-select w-auto">
                                                                <option>All contacts</option>
                                                            </select>
                                                        </div>
                                                        <div class="d-flex align-items-center justify-content-between mt-2">
                                                            <span class="text-dark">Edit</span>
                                                            <select class="custom-select w-auto">
                                                                <option>All contacts</option>
                                                            </select>
                                                        </div>
                                                        <div class="d-flex align-items-center justify-content-between mt-2">
                                                            <span class="text-dark">Delete <span class="badge badge-danger">CRITICAL</span></span>
                                                            <select class="custom-select w-auto">
                                                                <option>All contacts</option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <!-- Companies Section -->
                                        <div id="accordion2">
                                            <div class="card">
                                                <div class="card-header bg-grey-light">
                                                    <a class="card-link text-dark"
                                                       data-toggle="collapse"
                                                       href="#CompanyPermissions">
                                                        Companies
                                                    </a>
                                                </div>
                                                <div id="CompanyPermissions"
                                                     class="collapse show"
                                                     data-parent="#accordion2">
                                                    <div class="card-body bg-white">
                                                        <div class="d-flex align-items-center justify-content-between mt-2">
                                                            <span class="text-dark">View</span>
                                                            <select class="custom-select w-auto">
                                                                <option>All companies</option>
                                                            </select>
                                                        </div>
                                                        <div class="d-flex align-items-center justify-content-between mt-2">
                                                            <span class="text-dark">Edit</span>
                                                            <select class="custom-select w-auto">
                                                                <option>All companies</option>
                                                            </select>
                                                        </div>
                                                        <div class="d-flex align-items-center justify-content-between mt-2">
                                                            <span class="text-dark">Delete <span class="badge badge-danger">CRITICAL</span></span>
                                                            <select class="custom-select w-auto">
                                                                <option>All companies</option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </b-container>
</template>

<script>
export default {
    name: 'user-permission-tab',
    props: ['user']
}
</script>

<style scoped>
#accordion .card {
    margin-bottom: 0 !important;
}
.search-container {
    position: relative;
}
.search-container i {
    position: absolute;
    right: 10px;
    top: 50%;
    transform: translateY(-50%);
    pointer-events: none;
}
.min-w-25 {
    min-width: 25%;
}
</style>
